var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1306_788",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1306_788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 18C8.95 18 8.47917 17.8042 8.0875 17.4125C7.69583 17.0208 7.5 16.55 7.5 16V4C7.5 3.45 7.69583 2.97917 8.0875 2.5875C8.47917 2.19583 8.95 2 9.5 2H18.5C19.05 2 19.5208 2.19583 19.9125 2.5875C20.3042 2.97917 20.5 3.45 20.5 4V16C20.5 16.55 20.3042 17.0208 19.9125 17.4125C19.5208 17.8042 19.05 18 18.5 18H9.5ZM9.5 16H18.5V4H9.5V16ZM5.5 22C4.95 22 4.47917 21.8042 4.0875 21.4125C3.69583 21.0208 3.5 20.55 3.5 20V7C3.5 6.71667 3.59583 6.47917 3.7875 6.2875C3.97917 6.09583 4.21667 6 4.5 6C4.78333 6 5.02083 6.09583 5.2125 6.2875C5.40417 6.47917 5.5 6.71667 5.5 7V20H15.5C15.7833 20 16.0208 20.0958 16.2125 20.2875C16.4042 20.4792 16.5 20.7167 16.5 21C16.5 21.2833 16.4042 21.5208 16.2125 21.7125C16.0208 21.9042 15.7833 22 15.5 22H5.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.f20f330ab11d97a427bc3a13c8fe3ca7.svg";
export { ForwardRef as ReactComponent };